import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button, Result, Spin } from 'antd';
import { useDispatch } from 'react-redux';

import authService from '../../services/auth';
import { getUserInfoAsync } from '../../redux/slices/authSlice';

const WeChatCallbackPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');

    if (!code || !state) {
      setError('微信登录参数缺失，请重试');
      setLoading(false);
      return;
    }

    const run = async () => {
      try {
        const response = await authService.wechatCallback(code, state);
        const data = response.data;

        if (data?.needBindPhone) {
          const redirect = data.redirect || '/';
          navigate(`/auth/wechat/bind?token=${encodeURIComponent(data.bindToken)}&redirect=${encodeURIComponent(redirect)}`, { replace: true });
          return;
        }

        if (data?.user) {
          await dispatch(getUserInfoAsync());
          const redirect = data.redirect || '/';
          navigate(redirect, { replace: true });
          return;
        }

        setError('微信登录失败，请重试');
      } catch (e) {
        setError(e?.message || '微信登录失败，请重试');
      } finally {
        setLoading(false);
      }
    };

    run();
  }, [dispatch, navigate, searchParams]);

  if (loading) {
    return (
      <Result
        status="info"
        title="微信登录中"
        subTitle="正在处理微信授权回调，请稍候…"
        icon={<Spin size="large" />}
      />
    );
  }

  if (error) {
    return (
      <Result
        status="error"
        title="微信登录失败"
        subTitle={error}
        extra={[
          <Button type="primary" key="back" onClick={() => navigate('/auth/login', { replace: true })}>
            返回登录
          </Button>,
        ]}
      />
    );
  }

  return null;
};

export default WeChatCallbackPage;
